import React from "react";

export const GewoonZeker = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 43 45"
      fill="none"
      className={className}
    >
      <path
        d="M41.925 8.733a2.52 2.52 0 0 0-1.616-1.928L22.07.15a2.47 2.47 0 0 0-1.704 0L2.12 6.805A2.52 2.52 0 0 0 .504 8.733 33 33 0 0 0 0 14.48c0 13.729 8.404 25.484 20.312 30.342a2.4 2.4 0 0 0 1.81 0C34.03 39.964 42.43 28.21 42.43 14.48c0-1.963-.174-3.882-.504-5.747"
        fill="#052C25"
      />
      <path
        d="M20.618 24.775h5.818c-.588 2.013-2.185 3.769-4.841 3.769-3.411 0-5.88-2.674-5.88-6.3s2.463-6.3 5.88-6.3c1.957 0 3.554 1.152 4.42 2.503l3.272-1.842c-1.398-2.274-3.833-4.287-7.692-4.287-5.485 0-9.961 3.854-9.961 9.926s4.476 9.92 9.594 9.92c5.962 0 9.567-4.145 9.567-10.986H20.613v3.597z"
        fill="#fff"
      />
    </svg>
  );
};
